import React from 'react';
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Button,
} from '@mui/material';
import { Add } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const TestDashboard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          🧪 Test Dashboard
        </Typography>
        <Typography variant="body1" color="text.secondary">
          This is a test dashboard that bypasses authentication.
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {/* Monthly Cost Card */}
        <Grid item xs={12} md={3}>
          <Card>
            <CardContent>
              <Typography color="text.secondary" gutterBottom>
                Monthly Cost
              </Typography>
              <Typography variant="h4" component="div">
                $0.00
              </Typography>
              <Typography variant="body2" color="text.secondary">
                No subscriptions yet
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Total Subscriptions Card */}
        <Grid item xs={12} md={3}>
          <Card>
            <CardContent>
              <Typography color="text.secondary" gutterBottom>
                Total Subscriptions
              </Typography>
              <Typography variant="h4" component="div">
                0
              </Typography>
              <Typography variant="body2" color="text.secondary">
                No subscriptions added
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Upcoming Payments Card */}
        <Grid item xs={12} md={3}>
          <Card>
            <CardContent>
              <Typography color="text.secondary" gutterBottom>
                Upcoming Payments
              </Typography>
              <Typography variant="h4" component="div">
                0
              </Typography>
              <Typography variant="body2" color="text.secondary">
                No payments due
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Trial Ending Soon Card */}
        <Grid item xs={12} md={3}>
          <Card>
            <CardContent>
              <Typography color="text.secondary" gutterBottom>
                Trial Ending Soon
              </Typography>
              <Typography variant="h4" component="div">
                0
              </Typography>
              <Typography variant="body2" color="text.secondary">
                No trials ending
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Quick Actions */}
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Quick Actions
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Button
                  variant="contained"
                  startIcon={<Add />}
                  onClick={() => navigate('/add-subscription')}
                >
                  Add Subscription
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => navigate('/calendar')}
                >
                  View Calendar
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => navigate('/analytics')}
                >
                  View Analytics
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => navigate('/settings')}
                >
                  Settings
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Test Info */}
        <Grid item xs={12}>
          <Card sx={{ bgcolor: 'warning.light' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                🧪 Test Mode Active
              </Typography>
              <Typography variant="body2">
                This dashboard is running in test mode, bypassing authentication.
                All features should work normally.
              </Typography>
              <Button
                variant="contained"
                sx={{ mt: 2 }}
                onClick={() => navigate('/login')}
              >
                Go to Login
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default TestDashboard; 